import { getToken } from "../../../API/VolumesAPI";

// The one endpoint the new spuit program needs on top of the ones the other screens use (backend spray_program.py).
const SprayProgramAPI = {
  getChoices: async (cropId) => {
    const response = await fetch("/api/spray_program/choices/" + cropId, { headers: { Authorization: "Bearer " + getToken() } });
    if (!response.ok) throw new Error(`Kon nie die produk-keuses laai nie (${response.status})`);
    return response.json();
  },
};

export default SprayProgramAPI;
